import templateUrl from './publishingAtAGlance.html';
import './publishingAtAGlance.scss';

import {createLogger} from '../../common/logging.config';
const logger = createLogger('publishing-at-a-glance');

class PublishingAtAGlanceTabsController {
	constructor($scope, $rootScope, $timeout, $stateParams, publishingErrorService, homepageDataService, tenantRegistryService) {
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.homepageDataService = homepageDataService;
		

		// old constants for x1 tabs
		this.pendingTabId = 'pendingTab';
		this.publishedTabId = 'publishedTab';
		this.errorsTabId = 'errorsTab';
		
		this.errorCount = 0;
		this.returningFromAuthoringDetailsView = false;
		
		this.initialTab = 'pending'; 
		
		this.$onInit = () => {
			// get the WCH tier we are running
			this.tier = 'base';
			tenantRegistryService.getTenantInformation().then(
				(tenantData) => {
					// get the layout for that user
					this.tier = tenantData.tier.toLowerCase();
					if (this.tier === 'base') {
						this.initialTab = 'published'; 
					}
						},
				(error) => {
					logger.error('Error retrieving tenant tier info from server: ' + error.Error);
				}
			);
			
			// check to see if we are coming back from Publishing Job Details view and
			// if so return to the same tab
			logger.info('$stateParams = ' + JSON.stringify(this.$stateParams));
			if (this.$stateParams.paagTab && this.$stateParams.paagTab !== null) {
				this.initialTab = this.$stateParams.paagTab;
				this.returningFromAuthoringDetailsView = true;
			}

			// check to see if there are any publishing errors
			publishingErrorService.getCurrentErrorCount().then((data) =>  {
				logger.info("Publishing error count = " + data.count);
				this.errorCount = data.count;
				if (this.errorCount > 0) {
				
					if (this.returningFromAuthoringDetailsView === false) {
						this.initialTab = 'errors';
					}

					this.$timeout(() => {
					const errorsTabLink = document.querySelector("a#link-errors") || document.querySelector("li[index*='errors']>a");
						if (errorsTabLink) {
							errorsTabLink.setAttribute('data-attr', this.errorCount);
							errorsTabLink.classList.add('error-badge');
							// make the tabs code render again to layout with the error badge
							if (this.returningFromAuthoringDetailsView === false || this.initialTab === 'errors') {
								errorsTabLink.click();
							}
						}
					}, 1000);
				}
				else if (this.initialTab === 'published') {
					// make the tabs code render again to remove the next/prev arrows if not needed
					this.$timeout(() => {
						const publishedTabLink = document.querySelector("a#link-published");
						if (publishedTabLink) {
							publishedTabLink.click();
						}
					}, 5);
				}
			});
		}
	}
}

export default {
    bindings: {
        publishEvents: '<'
    },
	controller: [ '$scope', '$rootScope', '$timeout', '$stateParams', 'publishingErrorService', 'homepageDataService', 'tenantRegistryService', PublishingAtAGlanceTabsController ],
	templateUrl
};



// WEBPACK FOOTER //
// ./app/components/publishingAtAGlance/publishingAtAGlance.component.js